module.exports = __webpack_public_path__ + "static/media/green42.75829598.png";